import styled, { css } from 'styled-components'
import { maxXs } from '../../styles/breakPoints'

interface BackgroundProps {
  isOpen: boolean
}
export const Background = styled.div<BackgroundProps>`
  top: 0px;
  width: 100%;
  height: 100%;
  position: fixed;
  background: #0000008f;
  z-index: 2;

  ${(props) =>
    !props.isOpen &&
    css`
      display: none;
    `}
`

interface ContainerProps {
  isOpen: boolean
}
export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;

  width: 960px;
  height: 80%;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

  background: white;
  z-index: 2;

  button.close {
    justify-content: flex-end;
    display: flex;

    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  .bottom {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    button {
      width: 180px;
      height: 36px;

      span {
        font-family: proxima-nova;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: normal;
        text-align: left;
      }
    }
  }

  ${(props) =>
    !props.isOpen &&
    css`
      display: none;
    `}

  @media (${maxXs}) {
    width: 100%;
    height: 100%;
  }

  iframe {
    height: 100%;
  }
`
